import { Visibility, VisibilityOff } from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Box, Drawer, FormControl, IconButton, Input, Typography } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import loadergif from "assets/gif/payment_processing.gif";
import successGif from "assets/gif/payment_success.gif";
import { memo, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../../../../../../App";
import { useSnackbar } from "../../../../../hooks/SnackbarProvider";
import usePrint from "../../../../../hooks/usePrint";
import { addpin } from "../../../../redux/Actions/SessionActions";
import StyledButton from "../../../custom/StyledButton";
import "./index.css";
import "./restaurantPaymentModal.css";
import { getFromLocalStorage } from "../../../../../../../../utils/localStorageHelpers";
import { getStoreCurrencySymbol } from "../../../../../../../../utils/currency";
import { usePrinterAgentStatus } from "../../../../../../../../context/PrinterAgentContext";
import { applyRoundOff } from "../../../../utils/cartUtils";
import { getOrderDetails, restaurantCartUpdate } from "../../../../../../../../config/Services";
import PosCustomIcon from "../../../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import rePrintIconBlack from "../../../../../../../../assets/images/re-print-black.png";

/* ─── Inline SVG icons ─────────────────────────────────────────── */
const IconCash = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="2.5" />
    <path d="M6 12h.01M18 12h.01" />
  </svg>
);

const IconCard = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20" />
    <path d="M6 15h4" />
  </svg>
);

const IconUPI = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <path d="M9 18h6" />
    <rect x="8" y="6" width="8" height="7" rx="1" />
  </svg>
);

const IconCredit = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="12" y2="17" />
  </svg>
);

const IconSodexo = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <path d="M2 10h20" />
    <path d="M6 15h3M13 15h3" />
    <path d="M10 13v4" />
  </svg>
);

const IconSplit = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3v6" />
    <path d="M12 9l-5 5" />
    <path d="M12 9l5 5" />
    <path d="M7 14v3a2 2 0 0 0 2 2h1" />
    <path d="M17 14v3a2 2 0 0 0-2 2h-1" />
  </svg>
);

const IconTip = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  >
    <rect x="3" y="8" width="18" height="13" rx="2" />
    <path d="M12 8V5" />
    <path d="M8 5c0-1.1.9-2 2-2s2 .9 2 2" />
    <path d="M16 5c0-1.1-.9-2-2-2s-2 .9-2 2" />
    <path d="M3 13h18" />
  </svg>
);

const IconBill = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
    <path d="M12 17.5v-11" />
  </svg>
);

const IconClose = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

/* ─── Small helpers ─────────────────────────────────────────────── */
const methodIcon = (method) => {
  switch (method) {
    case "CASH":
      return <IconCash />;
    case "CARD":
      return <IconCard />;
    case "UPI":
      return <IconUPI />;
    case "DEBIT_NOTE":
      return <IconCredit />;
    case "SPLIT":
      return <IconSplit />;
    case "SODEXO":
      return <IconSodexo />;
    default:
      return <IconCard />;
  }
};

const methodLabel = (method) => {
  switch (method) {
    case "CASH":
      return "Cash";
    case "CARD":
      return "Card";
    case "UPI":
      return "UPI";
    case "DEBIT_NOTE":
      return "Credit";
    case "SPLIT":
      return "Split";
    case "SODEXO":
      return "Sodexo";
    default:
      return method;
  }
};

/* ═══════════════════════════════════════════════════════════════ */
/*  Main component                                                  */
/* ═══════════════════════════════════════════════════════════════ */
const PaymentModal = (props) => {
  const dispatch = useDispatch();
  const paymentMethodsString = localStorage.getItem("paymentMethods");
  const payment_modes = paymentMethodsString?.split(",");
  const splitRef = useRef(null);
  const cancelRef = useRef(null);
  const [isVisible, setVisible] = useState(false);
  const toggleVisibility = () => setVisible((v) => !v);
  const { startPrint, printToken, isPrinting, isError } = usePrint();
  const customerDetails = JSON.parse(localStorage.getItem("customer_details"));
  const branchSubType = localStorage.getItem("branchSubType");
  const retailType = localStorage.getItem("retailType");
  const customerPhoneNumber = customerDetails?.mobileNumber || "";
  const customerName = customerDetails?.name || "";
  const clickLock = useRef(false);
  const [showBillSummary, setShowBillSummary] = useState(false);
  const { isAgentRunning } = usePrinterAgentStatus();

  const cartStoreMode = localStorage.getItem("cartStoreMode");

  const [successAmount, setSuccessAmount] = useState(0);
  const [successMethod, setSuccessMethod] = useState("Cash");

  useEffect(() => {
    if (props?.openPayModal) {
      const amt = props?.adjustCheck ? props?.amtToBePaid : props?.total;
      if (amt) {
        setSuccessAmount(amt);
      }
      if (props?.paymentMethod) {
        setSuccessMethod(methodLabel(props?.paymentMethod));
      }
    }
  }, [
    props?.openPayModal,
    props?.total,
    props?.amtToBePaid,
    props?.adjustCheck,
    props?.paymentMethod,
  ]);

  const allowCreditPayment =
    getFromLocalStorage("appConfig")?.enabledFeatures?.ALLOW_CREDIT_PAYMENT;

  /* ── Context ─────────────────────────────────────────────────── */
  const {
    color,
    cartItems,
    total,
    cgst,
    sgst,
    subTotal,
    paymentMethod,
    setPaymentMethod,
    saleMode,
    setTotal: setContextTotal,
    setTotalTaxes: setContextTotalTaxes,
    taxes: contextTaxes,
    cartBilling: contextCartBilling,
  } = useContext(UserContext);

  const showSnackbar = useSnackbar();

  /* ── roundOff ────────────────────────────────────────────────── */
  let roundOffValue = undefined;
  let roundOffFloorValue = undefined;
  const appConfigRaw = localStorage.getItem("appConfig");
  if (appConfigRaw) {
    const appConfig = JSON.parse(appConfigRaw);
    const roundOff = appConfig?.enabledFeatures?.ROUND_OFF;
    // ROUND_OFF is a feature flag, not a number — it can arrive as a boolean,
    // a "true"/"false" string or a numeric value. parseFloat(true) is NaN, so
    // reading it as a number silently disabled rounding for the non-cash
    // methods (UPI / CARD) while cash rounded via its own branch.
    if (roundOff != null) {
      const numericRoundOff = parseFloat(roundOff);
      roundOffValue = Number.isFinite(numericRoundOff)
        ? numericRoundOff !== 0
        : roundOff !== false && String(roundOff).toLowerCase() !== "false" && roundOff !== "";
    }
    roundOffFloorValue = appConfig?.settings?.ROUND_OFF?.roundOffFloor;
  }
  const roundAmountValue = (amount) => applyRoundOff(amount, roundOffFloorValue);

  /* ═══════════════════════════════════════════════════════════════
     RESTAURANT VARIANT
     Everything below is inert unless the caller passes variant="restaurant".
     Grocery / orders / credit-order call sites keep their exact behavior.
     ═══════════════════════════════════════════════════════════════ */
  const isRestaurantVariant = props?.variant === "restaurant";
  const navigate = useNavigate();

  const billPrintMode = props?.billPrintMode || "ASK";
  const kotPrintMode = props?.kotPrintMode || "ASK";
  const effectiveSaleMode = props?.saleMode || saleMode || localStorage.getItem("saleMode");
  const isDeliveryOrTakeaway =
    effectiveSaleMode === "DELIVERY" || effectiveSaleMode === "TAKE_AWAY";
  const summaryData = props?.orderSummary || {};

  const taxesList = useMemo(() => {
    if (Array.isArray(props?.taxes) && props.taxes.length > 0) return props.taxes;
    if (Array.isArray(props?.billing?.taxes) && props.billing.taxes.length > 0) return props.billing.taxes;
    if (Array.isArray(summaryData?.taxes) && summaryData.taxes.length > 0) return summaryData.taxes;
    if (Array.isArray(contextTaxes) && contextTaxes.length > 0) return contextTaxes;
    if (Array.isArray(contextCartBilling?.taxes) && contextCartBilling.taxes.length > 0) return contextCartBilling.taxes;
    try {
      const localBilling = JSON.parse(localStorage.getItem("cartBilling") || "null");
      if (Array.isArray(localBilling?.taxes) && localBilling.taxes.length > 0) {
        return localBilling.taxes;
      }
    } catch (_) {}
    return [];
  }, [props?.taxes, props?.billing, summaryData?.taxes, contextTaxes, contextCartBilling]);

  const taxesToRender = useMemo(() => {
    if (!Array.isArray(taxesList) || taxesList.length === 0) return [];
    const nonZero = taxesList.filter((tax) => {
      const amount = tax?.totalTaxAmount ?? tax?.taxAmount ?? tax?.amount ?? tax?.value;
      return amount !== undefined && amount !== null && Number(amount) > 0;
    });
    return nonZero.length > 0 ? nonZero : taxesList;
  }, [taxesList]);

  const [printKotLoading, setPrintKotLoading] = useState(false);
  const [homeCountdown, setHomeCountdown] = useState(7);
  const countdownIntervalRef = useRef(null);
  const orderCompleteLock = useRef(false);
  // Set when "Print Bill & Pay" runs against an order that does not exist yet —
  // the bill is then printed as soon as the payment succeeds.
  const pendingBillPrintRef = useRef(false);

  // Restaurant always rounds; grocery only rounds when ROUND_OFF is configured.
  const payableAmountValue = (amount) => {
    if (amount === undefined || amount === null || amount === "") return amount;
    return applyRoundOff(amount, roundOffFloorValue);
  };

  /* ── Extra charges (delivery / packing) ──────────────────────── */
  const [extrasOpen, setExtrasOpen] = useState(false);
  const [localDeliveryCharge, setLocalDeliveryCharge] = useState("");
  const [localPackingCharge, setLocalPackingCharge] = useState("");
  const [chargesApplying, setChargesApplying] = useState(false);

  useEffect(() => {
    if (!isRestaurantVariant || !props?.openPayModal) return;
    setLocalDeliveryCharge(
      summaryData?.deliveryChargesDisplay > 0 ? String(summaryData.deliveryChargesDisplay) : ""
    );
    setLocalPackingCharge(
      summaryData?.packingChargesDisplay > 0 ? String(summaryData.packingChargesDisplay) : ""
    );
    setExtrasOpen(false);
    pendingBillPrintRef.current = false;
  }, [props?.openPayModal, isRestaurantVariant]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChargeChange = (value, type) => {
    if (value === ".") value = "0.";
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    if (type === "delivery") setLocalDeliveryCharge(value);
    else setLocalPackingCharge(value);
  };

  const handleApplyCharges = () => {
    if (chargesApplying) return;
    const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
    const userName = localStorage.getItem("user_name");
    const locId = localStorage.getItem("locId");
    const cartId = props?.cartId || localStorage.getItem("CartId");
    setChargesApplying(true);
    restaurantCartUpdate({
      cartId: cartId || "",
      packingCharges: localPackingCharge ? Number(localPackingCharge) : 0,
      ...(effectiveSaleMode === "DELIVERY" && {
        deliveryCharges: localDeliveryCharge ? Number(localDeliveryCharge) : 0,
      }),
      updatedBy: retailUserDetails?.uidx || "",
      updatedByName: userName || "",
      sourceLocationId: locId,
      orderType: retailType === "RESTAURANT" ? "RESTAURANT_ORDER" : "POS_ORDER",
      destinationLocationId: locId,
      loggedInUser: retailUserDetails?.uidx || "",
    })
      .then((res) => {
        if (
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.data?.message || "Unable to update charges", "error");
          return;
        }
        const billing = res?.data?.data?.data?.billing;
        props?.setDeliveryCharge?.(billing?.deliveryCharges || 0);
        props?.setPackingCharge?.(billing?.packingCharges || 0);
        if (billing?.totalCartValue !== undefined) setContextTotal?.(billing.totalCartValue);
        if (billing?.tax !== undefined) setContextTotalTaxes?.(billing.tax);
        showSnackbar("Extra charges applied", "success");
        setExtrasOpen(false);
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || err?.message || "Unable to update charges",
          "error"
        );
      })
      .finally(() => setChargesApplying(false));
  };

  /* ── Payment buttons (no SODEXO in the card row) ─────────────── */
  const paymentButtons = useMemo(() => {
    const buttons = [
      { method: "CASH", label: "Cash" },
      { method: "CARD", label: "Card" },
      { method: "UPI", label: "UPI" },
    ];
    // Restaurant allows credit too; grocery keeps its non-RESTAURANT guard.
    const creditAllowed =
      allowCreditPayment &&
      customerPhoneNumber &&
      customerName &&
      (isRestaurantVariant || retailType !== "RESTAURANT");
    if (creditAllowed) {
      buttons.push({ method: "DEBIT_NOTE", label: "Credit" });
    }
    if (!props?.hideSplitPayment) {
      buttons.push({ method: "SPLIT", label: "Split" });
    }
    // hideSodexo lets callers (e.g. table-layout) suppress Sodexo when their payment
    // flow does not yet support terminal-based processing for this method.
    if (payment_modes?.includes("SODEXO") && !props?.hideSodexo) {
      buttons.push({ method: "SODEXO", label: "Sodexo" });
    }
    return buttons;
  }, [
    customerPhoneNumber,
    customerName,
    allowCreditPayment,
    retailType,
    paymentMethodsString,
    isRestaurantVariant,
    props?.hideSplitPayment,
    props?.hideSodexo,
  ]);

  /* ── renderTotalAmount ───────────────────────────────────────── */
  const renderTotalAmount = useMemo(() => {
    let roundAmount = 0;
    if (props?.partialStatus && !props?.splitActive) {
      roundAmount = props?.total - props?.amountPaid;
    } else {
      roundAmount = props?.adjustCheck
        ? props?.amtToBePaid
        : props?.splitActive
        ? props?.enterAmount || 0
        : props?.total;
    }
    if (props?.amtHeading === "Recievable Amount" && props?.adjustCheck) {
      return `REFUND ${getStoreCurrencySymbol()}${
        props?.paymentMethod === "CASH" || roundOffValue
          ? roundAmountValue(roundAmount)
          : roundAmount
      }`;
    }
    if (props?.paymentMethod === "DEBIT_NOTE") {
      return "Credit Order Creation";
    }
    return `PAY ${getStoreCurrencySymbol()}${
      props?.paymentMethod === "CASH" || roundOffValue ? roundAmountValue(roundAmount) : roundAmount
    }`;
  }, [
    props?.partialStatus,
    props?.total,
    props?.amountPaid,
    props?.adjustCheck,
    props?.splitActive,
    props?.amtToBePaid,
    props?.paymentMethod,
    props?.enterAmount,
    props?.amtHeading,
    roundOffValue,
    roundOffFloorValue,
  ]);

  /* ── Computed display values ─────────────────────────────────── */
  const due = props?.adjustCheck ? props?.amtToBePaid : props?.total;
  const enteredAmt = Number(props?.enterAmount) || 0;
  const collected = props?.partialStatus
    ? Number(props?.amountPaid)
    : enteredAmt > 0
    ? enteredAmt
    : 0;
  const remaining = Math.max(0, roundAmountValue(Number(due)) - collected);

  // Compare against the rounded due — the cashier is shown (and can enter) the
  // rounded amount, so 11 against a 10.7 total is not an overpayment
  const isSplitOverpaid =
    props?.splitActive &&
    props?.paymentMethod !== "CASH" &&
    enteredAmt > roundAmountValue(Number(props?.partialStatus ? props?.amountDue : props?.total));

  const isProcessing =
    props?.newLoader || props?.modalLoader || props?.payLoader || props?.paymentLoader;

  const displayDue =
    props?.paymentMethod !== "CASH"
      ? props?.amtHeading === "Recievable Amount"
        ? roundAmountValue(Number(props?.amtToBePaid))
        : props?.partialStatus
        ? roundAmountValue(Number(props?.amountDue))
        : roundOffValue
        ? roundAmountValue(Number(props?.total))
        : props?.total
      : roundAmountValue(Number(due));

  /* ── Restaurant: amount validation ───────────────────────────── */
  // The restaurant flow settles a placed bill, so it must be paid in full —
  // grocery keeps allowing a short cash tender (it computes change instead).
  const restaurantDue = props?.partialStatus
    ? Number(payableAmountValue(props?.amountDue || 0))
    : Number(payableAmountValue(props?.adjustCheck ? props?.amtToBePaid : props?.total || 0));

  const isCashUnderpayment =
    isRestaurantVariant &&
    props?.paymentMethod === "CASH" &&
    !props?.splitActive &&
    enteredAmt > 0 &&
    enteredAmt < restaurantDue &&
    !props?.isCreditPayment;

  const isZeroAmountOrder = isRestaurantVariant && Number(props?.total) === 0;

  /* ── handleClick (with click-lock) ──────────────────────────── */
  const handleClick = async () => {
    if (clickLock.current || isSplitOverpaid || isProcessing) return;

    if (isCashUnderpayment) {
      showSnackbar(
        "Amount entered is less than the total due. Please enter the full amount.",
        "error"
      );
      return;
    }

    if (
      !isZeroAmountOrder &&
      props?.paymentMethod === "CASH" &&
      !props?.splitActive &&
      !props?.enterAmount
    ) {
      showSnackbar("Please enter a valid amount to Proceed", "error");
      return;
    }

    clickLock.current = true;
    try {
      if (!props?.partialStatus || props?.cancelSingle) {
        await props?.checkPayment?.();
        if (isRestaurantVariant) {
          props?.setPackingCharge?.("");
          props?.setDeliveryCharge?.("");
          if (props?.splitActive) {
            localStorage.removeItem("CartId");
          }
        }
      } else {
        await props?.partialCompletePayment?.();
      }
    } finally {
      clickLock.current = false;
    }
  };

  // Restaurant clamps the tender to 2dp and rounds full (non-split) payments to the
  // charged amount; grocery keeps taking the raw input and computing change.
  const handleCashAmountChange = (e) => {
    let value = e.target.value;
    if (!isRestaurantVariant) {
      props?.setEnterAmount?.(value);
      return;
    }
    if (value === ".") value = "0.";
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    if (value && !props?.splitActive) {
      props?.setEnterAmount?.(String(payableAmountValue(value)));
    } else {
      props?.setEnterAmount?.(value);
    }
  };

  // Focus the "Amount received" input when the restaurant drawer opens
  useEffect(() => {
    if (!isRestaurantVariant || !props?.openPayModal) return;
    const timer = setTimeout(() => props?.enterAmountRef?.current?.focus(), 300);
    return () => clearTimeout(timer);
  }, [props?.openPayModal, isRestaurantVariant]); // eslint-disable-line react-hooks/exhaustive-deps

  /* ── Restaurant: Print Bill and Pay ──────────────────────────── */
  const printBillForOrder = (billOrderId) => {
    startPrint({
      orderId: billOrderId,
      skipKot: true,
      ...(effectiveSaleMode === "DELIVERY" && { orderSource: "b2c" }),
    });
  };

  // BILL_PRINT_MODE = "ASK" only: print the bill, then complete the payment
  // exactly like the pay button. If the order does not exist yet (nothing to
  // print), the bill is printed as soon as the payment succeeds.
  const handlePrintBillAndPay = () => {
    if (clickLock.current) return;
    const existingBillOrderId = props?.isBillPrinted ? props?.printedBillOrderId : null;
    if (existingBillOrderId) {
      pendingBillPrintRef.current = false;
      printBillForOrder(existingBillOrderId);
    } else {
      pendingBillPrintRef.current = true;
    }
    handleClick();
  };

  const handleProcessPaymentClick = () => {
    pendingBillPrintRef.current = false;
    handleClick();
  };

  // "Print Bill & Pay" on an order created by this payment — print once it exists
  useEffect(() => {
    if (!isRestaurantVariant || !props?.paymentSuccess || !pendingBillPrintRef.current) return;
    pendingBillPrintRef.current = false;
    const successOrderId = props?.newId || props?.orderId;
    if (successOrderId) printBillForOrder(successOrderId);
  }, [props?.paymentSuccess, isRestaurantVariant]); // eslint-disable-line react-hooks/exhaustive-deps

  /* ── Keyboard: F2 / Backspace / reset flags ──────────────────── */
  useEffect(() => {
    if (props?.openPayModal) {
      const handleKeyPress = (event) => {
        if (event.keyCode === 113) {
          if (branchSubType === "FINE_DINE") return;
          if (!props?.functionCalled && !props?.partialStatus && props?.paymentMethod === "CASH") {
            event.preventDefault();
            props?.createOrderFun?.();
            props?.setFunctionCalled?.(true);
          } else if (
            !props?.functionCalled &&
            !props?.partialStatus &&
            props?.paymentMethod === "DEBIT_NOTE"
          ) {
            props?.createDebitFun?.();
          } else if (
            !props?.cardFunctionCalled &&
            !props?.partialStatus &&
            (props?.paymentMethod === "UPI" ||
              props?.paymentMethod === "CARD" ||
              props?.paymentMethod === "SODEXO")
          ) {
            event.preventDefault();
            props?.digitalPaymentFunUPI?.();
            props?.setCardFunctionCalled?.(true);
          } else if (props?.partialStatus) {
            event.preventDefault();
            props?.partialCompletePayment?.();
            props?.setSplitFunctionCalled?.(true);
          }
        } else if (event.keyCode === 8) {
          props?.setEnterAmount?.("");
        } else {
          props?.setFunctionCalled?.(false);
          props?.setCardFunctionCalled?.(false);
          props?.setSplitFunctionCalled?.(false);
        }
      };
      window.addEventListener("keydown", handleKeyPress);
      return () => window.removeEventListener("keydown", handleKeyPress);
    }
  }, [
    props?.openPayModal,
    props?.functionCalled,
    props?.paymentMethod,
    props?.cardFunctionCalled,
    props?.partialStatus,
    props?.enterAmount,
    props?.singleOrderoffline,
    props?.splitActive,
    props?.adjustCheck,
    props?.paymentFailed,
    props?.paymentSuccess,
    props?.manual,
    props?.paymentCancel,
    props?.newTransId,
  ]);

  /* ── Keyboard: F12 Print Receipt when success screen is active ── */
  useEffect(() => {
    if (props?.openPayModal && props?.paymentSuccess) {
      const handleKeyPress = (event) => {
        if (event.key === "F12") {
          event.preventDefault();
          const orderId = props?.newId || props?.orderId;
          if (orderId && !isPrinting && !props?.isPrinting) {
            startPrint({ orderId });
          }
        }
      };
      window.addEventListener("keydown", handleKeyPress);
      return () => window.removeEventListener("keydown", handleKeyPress);
    }
  }, [
    props?.openPayModal,
    props?.paymentSuccess,
    props?.newId,
    props?.orderId,
    isPrinting,
    props?.isPrinting,
  ]);

  /* ── Initial payment method ──────────────────────────────────── */
  useEffect(() => {
    props?.setPaymentMethod?.("CASH");
  }, []);

  /* ── Keyboard: ArrowLeft / ArrowRight navigation ─────────────── */
  useEffect(() => {
    const focusSplitButton = () => {
      if (splitRef.current && !props?.splitActive) {
        splitRef.current.focus();
      } else if (cancelRef.current && props?.splitActive) {
        cancelRef.current.focus();
      }
    };
    const blurSplitButton = (payment_mode) => {
      props?.setPaymentMethod?.(payment_mode);
      if (splitRef.current) splitRef.current.blur();
      if (cancelRef.current) cancelRef.current.blur();
    };
    const handleKeyDown = (event) => {
      const { paymentMethod: pm, openPayModal } = props;
      if (!openPayModal) return;
      switch (event.key) {
        case "ArrowRight":
          switch (pm) {
            case "CASH":
              props?.setPaymentMethod?.("UPI");
              break;
            case "UPI":
              props?.setPaymentMethod?.("CARD");
              break;
            case "CARD":
              if (
                allowCreditPayment &&
                customerPhoneNumber &&
                customerName &&
                retailType !== "RESTAURANT"
              ) {
                props?.setPaymentMethod?.("DEBIT_NOTE");
              } else if (payment_modes?.includes("SODEXO")) {
                props?.setPaymentMethod?.("SODEXO");
              } else {
                focusSplitButton();
              }
              break;
            case "DEBIT_NOTE":
              if (payment_modes?.includes("SODEXO")) {
                props?.setPaymentMethod?.("SODEXO");
              } else {
                focusSplitButton();
              }
              break;
            case "SODEXO":
              focusSplitButton();
              break;
            default:
              break;
          }
          break;
        case "ArrowLeft":
          switch (pm) {
            case "SODEXO":
              if (
                allowCreditPayment &&
                customerPhoneNumber &&
                customerName &&
                !props?.splitActive &&
                retailType !== "RESTAURANT"
              ) {
                blurSplitButton("DEBIT_NOTE");
              } else {
                blurSplitButton("CARD");
              }
              break;
            case "DEBIT_NOTE":
              blurSplitButton("CARD");
              break;
            case "CARD":
              blurSplitButton("UPI");
              break;
            case "UPI":
              props?.setPaymentMethod?.("CASH");
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [
    props?.paymentMethod,
    props?.openPayModal,
    props?.splitActive,
    cancelRef,
    splitRef,
    props?.paymentFailed,
    props?.paymentSuccess,
    props?.manual,
    props?.paymentCancel,
  ]);

  /* ── Keyboard: prevent ArrowUp/Down on number inputs ─────────── */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (document.activeElement && document.activeElement.type === "number") {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
          e.preventDefault();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  /* ── Handlers ────────────────────────────────────────────────── */
  const handleSplitCancel = () => {
    props?.setSplitActive?.(false);
    props?.setPaymentMethod?.("CASH");
  };

  const handleOrderComplete = () => {
    if (!isRestaurantVariant) {
      props?.setPaymentSuccess?.(false);
      props?.closePaymentModal?.();
      props?.setOpen?.(true);
      props?.setPaymentMethod?.("CASH");
      props?.setpaymentLoader?.(false);
      return;
    }

    if (orderCompleteLock.current) return;
    orderCompleteLock.current = true;

    props?.setPaymentSuccess?.(false);
    props?.closePaymentModal?.(true);
    props?.setpaymentLoader?.(false);
    props?.resetValues?.();

    if (
      retailType === "RESTAURANT" &&
      branchSubType === "FINE_DINE" &&
      effectiveSaleMode === "DINE_IN"
    ) {
      props?.setShowFineDineActionButtons?.(false);
      navigate("/products/table-layout");
    }

    if (
      effectiveSaleMode === "TAKE_AWAY" ||
      effectiveSaleMode === "DELIVERY" ||
      (effectiveSaleMode === "DINE_IN" && branchSubType !== "FINE_DINE")
    ) {
      props?.setOpenCartCustomerDetail?.(true);
    }

    props?.setOpen?.(true);
    props?.setPaymentMethod?.("CASH");
  };

  /* ── Restaurant: success screen actions ──────────────────────── */
  const showRestaurantSuccessActions =
    isRestaurantVariant &&
    (branchSubType === "QSR" ||
      (branchSubType === "FINE_DINE" && effectiveSaleMode === "DINE_IN") ||
      effectiveSaleMode === "TAKE_AWAY" ||
      effectiveSaleMode === "DELIVERY" ||
      effectiveSaleMode === "delivery");
  const showPrintActions =
    showRestaurantSuccessActions && (billPrintMode !== "NEVER" || kotPrintMode !== "NEVER");

  const stopHomeCountdown = () => {
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }
    setHomeCountdown(0);
  };

  const handleSuccessKotPrint = async () => {
    stopHomeCountdown();
    if (printKotLoading) return;

    const successOrderId = props?.newId || props?.orderId;

    // Fine dine settles an already-placed cart, so the KOT must be reprinted from
    // the completed order (same as the Orders page) — the cart-based token APIs no
    // longer apply once payment is done.
    if (branchSubType === "FINE_DINE" && effectiveSaleMode === "DINE_IN") {
      if (!successOrderId) {
        showSnackbar("Order not found to print KOT", "error");
        return;
      }
      setPrintKotLoading(true);
      try {
        const res = await getOrderDetails(successOrderId, localStorage.getItem("locId"));
        const orderDetails = res?.data?.data || {};
        const orderItems = orderDetails?.baseOrderResponse?.orderItemList || [];
        if (!orderItems.length) {
          throw new Error("No KOT items found to print");
        }
        const selectedTableData = JSON.parse(localStorage.getItem("selectedTableData") || "{}");
        await printToken({
          tableId: orderDetails?.baseOrderResponse?.tableId || null,
          tokenNumber:
            orderDetails?.orderTokenDetails?.token ||
            orderDetails?.orderTokenDetails?.tokenNumber ||
            "NA",
          tableNumber: orderDetails?.baseOrderResponse?.tableNumber,
          subOrderType: orderDetails?.baseOrderResponse?.subOrderType,
          customerName: orderDetails?.baseOrderResponse?.customerName || "Walk-in Customer",
          orderItems,
          comments: orderDetails?.baseOrderResponse?.comments || "N/A",
          layoutName:
            orderDetails?.baseOrderResponse?.layoutName || selectedTableData?.layoutName || null,
          startTime: orderDetails?.baseOrderResponse?.startTime,
          endTime: orderDetails?.baseOrderResponse?.endTime,
        });
        showSnackbar("KOT printed successfully", "success");
      } catch (error) {
        showSnackbar("Failed to print KOT", "error");
      } finally {
        setPrintKotLoading(false);
      }
      return;
    }

    startPrint({ orderId: successOrderId, printType: "kot", skipBill: true });
  };

  // Auto "Go to Home" countdown once a restaurant payment succeeds
  useEffect(() => {
    if (!props?.paymentSuccess || !showRestaurantSuccessActions) return;
    orderCompleteLock.current = false;
    setHomeCountdown(7);
    const interval = setInterval(() => {
      setHomeCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          countdownIntervalRef.current = null;
          handleOrderComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    countdownIntervalRef.current = interval;
    return () => {
      clearInterval(interval);
      countdownIntervalRef.current = null;
    };
  }, [props?.paymentSuccess, showRestaurantSuccessActions]); // eslint-disable-line react-hooks/exhaustive-deps

  /* ── Method card click ───────────────────────────────────────── */
  const handleMethodClick = (method) => {
    if (method === "SPLIT") {
      props?.handleSplitPayment?.();
      props?.setPartailStatus?.(false);
    } else {
      props?.setPaymentMethod?.(method);
      if (props?.splitActive) {
        // keep split active but switch method
      }
    }
  };

  /* ── Change calculation ──────────────────────────────────────── */
  const changeAmount = (() => {
    if (props?.adjustCheck) {
      return (Number(props?.enterAmount) - roundAmountValue(Number(props?.amtToBePaid))).toFixed(2);
    }
    if (props?.cashChange) {
      return props?.amountDue;
    }
    return (Number(props?.enterAmount) - roundAmountValue(Number(props?.total))).toFixed(2);
  })();

  const hasChange = props?.paymentMethod === "CASH" && Number(changeAmount) > 0;
  const hasRemaining = remaining > 0;

  /* ── Split payment list (captured so far) ───────────────────── */
  const [splitPayments, setSplitPayments] = useState([]);
  const prevAmountPaidRef = useRef(0);

  useEffect(() => {
    if (!props?.openPayModal || !props?.partialStatus) {
      setSplitPayments([]);
      prevAmountPaidRef.current = 0;
    } else {
      const currentPaid = Number(props?.amountPaid) || 0;
      const prevPaid = prevAmountPaidRef.current;
      if (currentPaid > prevPaid) {
        setSplitPayments((prev) => [
          ...prev,
          {
            method: methodLabel(props?.paymentMethod),
            amount: currentPaid - prevPaid,
          },
        ]);
        prevAmountPaidRef.current = currentPaid;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.openPayModal, props?.partialStatus, props?.amountPaid]);

  /* ═══════════════════════════════════════════════════════════════
     RENDER
     ═══════════════════════════════════════════════════════════════ */
  return (
    <>
      <Drawer
        anchor="right"
        open={props?.openPayModal}
        onClose={
          (props?.partialStatus && !props?.canceledOnce) || props?.splitActive
            ? undefined
            : props?.closePaymentModal
        }
        PaperProps={{ className: "gpm-drawer-paper" }}
        sx={{ zIndex: 1400 }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
          {/* ───────────── LOADER SCREENS ───────────── */}
          {props?.paymentLoader ? (
            <div className={`gpm-loader-shell ${props?.paymentSuccess ? "success" : ""}`}>
              <div className="gpm-loader-box">
                {props?.manual ? (
                  /* Manual processing */
                  <div style={{ width: "100%" }}>
                    <div className="process-wrapper-box">
                      <h3 className="process-wrapper-txt">Process your order manually</h3>
                      <h4>Customer Transaction Id</h4>
                      <FormControl sx={{ width: "100%" }} variant="outlined">
                        <Input
                          className="input-wrapper-manual"
                          type="number"
                          disableUnderline
                          value={props?.transCode}
                        />
                      </FormControl>
                      <h4>Cashier Pin</h4>
                      <FormControl sx={{ width: "100%" }} variant="outlined">
                        <Input
                          onChange={(e) => dispatch(addpin(e.target.value))}
                          className="input-wrapper-manual"
                          type={isVisible ? "number" : "password"}
                          disableUnderline
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={toggleVisibility}
                                edge="end"
                              >
                                {isVisible ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="bottom-btn-wrapper">
                      <StyledButton
                        loading={props?.approveloader}
                        disabled={!props?.cashierPin}
                        onClick={props?.handleManualorders}
                      >
                        Approve
                      </StyledButton>
                    </div>
                  </div>
                ) : props?.paymentFailed ? (
                  /* Payment failed */
                  <div>
                    <h2 className="payemnt-failed-txt">
                      payment not processed &mdash; <b className="orderNumber">{props?.newId}</b>
                    </h2>
                    <div className="failed-img-gif-wrapper">
                      <img className="failed-img-gif" src={props?.failedImgWarning} alt="Err" />
                    </div>
                    <div className="styledButton-wrapper-box">
                      {props?.cancelTrans ? (
                        <StyledButton onClick={props?.handleTansactionCancel}>Cancel</StyledButton>
                      ) : (
                        <StyledButton
                          loading={props?.cancelLoader}
                          onClick={props?.handleTansactionCancel}
                        >
                          Cancel
                        </StyledButton>
                      )}
                    </div>
                  </div>
                ) : props?.paymentSuccess ? (
                  /* Payment success */
                  <div className="payment-success-main-box">
                    <div className="success-icon-wrapper">
                      <div className="success-icon-check">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-circle-check success-check-svg"
                          aria-hidden="true"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="m9 12 2 2 4-4" />
                        </svg>
                      </div>
                      <div className="success-icon-pulse" />
                    </div>

                    <h2 className="success-title" data-testid="text-payment-success-title">
                      Payment Successful!
                    </h2>

                    <p className="success-amount" data-testid="text-payment-success-amount">
                      Amount of {getStoreCurrencySymbol()}{roundAmountValue(Number(successAmount))} received
                    </p>

                    <p className="success-method" data-testid="text-payment-success-method">
                      Settled via {successMethod}
                    </p>

                    {showRestaurantSuccessActions ? (
                      <>
                        {showPrintActions && (
                          <div className="rpm-success-actions">
                            {billPrintMode !== "NEVER" && (
                              <button
                                className="rpm-btn rpm-btn-outline rpm-success-action-btn"
                                data-testid="button-print-bill"
                                onClick={() => {
                                  stopHomeCountdown();
                                  printBillForOrder(props?.newId || props?.orderId);
                                }}
                              >
                                <PrintOutlinedIcon sx={{ fontSize: "1rem" }} />
                                Print Bill
                              </button>
                            )}
                            {kotPrintMode !== "NEVER" && (
                              <button
                                className="rpm-btn rpm-btn-outline rpm-success-action-btn"
                                data-testid="button-print-kot"
                                disabled={printKotLoading}
                                onClick={handleSuccessKotPrint}
                              >
                                <PosCustomIcon
                                  image={rePrintIconBlack}
                                  height={"16px"}
                                  width={"16px"}
                                />
                                {printKotLoading ? "Printing..." : "Print KOT"}
                              </button>
                            )}
                          </div>
                        )}
                        <div className="rpm-success-footer">
                          <button
                            className="rpm-btn rpm-btn-dark"
                            onClick={handleOrderComplete}
                            data-testid="button-go-home"
                          >
                            Go to Home ({homeCountdown}s)
                            <HomeOutlinedIcon sx={{ fontSize: "1rem" }} />
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="success-actions-grid">
                          <button
                            className="success-action-btn btn-print-bill"
                            data-testid="button-print-bill"
                            disabled={isPrinting || props?.isPrinting}
                            onClick={() => startPrint({ orderId: props?.newId || props?.orderId })}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-printer success-action-svg"
                              aria-hidden="true"
                            >
                              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                              <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
                              <rect x="6" y="14" width="12" height="8" rx="1" />
                            </svg>
                            <span className="font-bold">
                              {isPrinting || props?.isPrinting ? "Printing..." : "Print Bill (F12)"}
                            </span>
                          </button>

                          <button
                            className="success-action-btn btn-email-invoice"
                            data-testid="button-email-invoice"
                            disabled
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-mail success-action-svg"
                              aria-hidden="true"
                            >
                              <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                              <rect x="2" y="4" width="20" height="16" rx="2" />
                            </svg>
                            <span className="font-bold">E-Invoice</span>
                          </button>
                        </div>

                        <div className="success-footer-btns">
                          <button
                            autoFocus
                            className="gpm-btn-primary continue-btn-wrapper"
                            onClick={handleOrderComplete}
                            data-testid="button-go-home"
                          >
                            Go to Home
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-house success-home-svg"
                              aria-hidden="true"
                            >
                              <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                              <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            </svg>
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ) : props?.paymentCancel ? (
                  /* Payment cancelled */
                  <div>
                    <div className="failed-img-gif-wrapper">
                      <img
                        className="loading-img-gif-success"
                        src={props?.cancelGif}
                        alt="cancelled"
                      />
                    </div>
                    <h3 className="payment-cancel">Payment cancel</h3>
                    <StyledButton
                      className="cancel-wrapper-btn"
                      loading={props?.cancelLoader}
                      onClick={props?.handleTansactionCancel}
                    >
                      Cancel
                    </StyledButton>
                  </div>
                ) : (
                  /* Loading gif */
                  <div>
                    <h4 className="payment-progress-text">{props?.paymentMethod} Payment</h4>
                    <div className="failed-img-gif-wrapper">
                      <img className="loading-img-gif" src={loadergif} alt="processing" />
                    </div>
                    <div className="styledButton-wrapper-box">
                      <StyledButton
                        loading={props?.cancelLoader}
                        onClick={props?.handleTansactionCancel}
                      >
                        Cancel
                      </StyledButton>
                      <StyledButton onClick={props?.handleManual}>Manual</StyledButton>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            /* ─────────── MAIN PAYMENT UI ─────────── */
            <div className="gpm-shell">
              {/* ── Header ── */}
              <div className="gpm-header">
                <div className="gpm-header-left">
                  <h2>Payment</h2>
                </div>
                <div className="gpm-header-right">
                  {isRestaurantVariant && isDeliveryOrTakeaway && (
                    <button
                      className={`rpm-extras-toggle-btn${extrasOpen ? " open" : ""}`}
                      onClick={() => setExtrasOpen((o) => !o)}
                      type="button"
                      data-testid="button-payment-extra-charges"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                        <path d="M12 22V12" />
                        <polyline points="3.29 7 12 12 20.71 7" />
                        <path d="m7.5 4.27 9 5.15" />
                      </svg>
                      Extra charges
                    </button>
                  )}
                  <button className="gpm-bill-btn" onClick={() => setShowBillSummary(true)}>
                    <IconBill />
                    Bill Summary
                  </button>
                  {props?.forceOfflinePay ? (
                    /* Order-details forced-offline mode — EDC machine is bypassed */
                    <div className="gpm-edc-badge force-offline">
                      <span className="gpm-edc-dot" />
                      Offline Payment Mode
                    </div>
                  ) : (
                    <div
                      className={`gpm-edc-badge ${
                        cartStoreMode === "ONLINE" ? "connected" : "disconnected"
                      }`}
                    >
                      <span className="gpm-edc-dot" />
                      {cartStoreMode === "ONLINE" ? "EDC connected" : "EDC offline"}
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                        <path d="M1.42 9a16 16 0 0 1 21.16 0" />
                        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
                        <line x1="12" y1="20" x2="12.01" y2="20" />
                      </svg>
                    </div>
                  )}
                  <button
                    className="gpm-close-btn"
                    onClick={props?.closePaymentModal}
                    disabled={
                      props?.splitActive &&
                      (props?.partialStatus || isProcessing || splitPayments.length > 0)
                    }
                  >
                    <IconClose />
                  </button>
                </div>
              </div>

              {/* ── Extras (delivery / packing charges) ── */}
              {isRestaurantVariant && isDeliveryOrTakeaway && extrasOpen && (
                <div className="rpm-extras-top">
                  <div className="rpm-manual-charges">
                    <div className="rpm-manual-charges-header">
                      <div className="rpm-manual-charges-info">
                        <span className="rpm-manual-charges-title">MANUAL CHARGES</span>
                        <p>Add packing and delivery here, then press Apply to update the bill.</p>
                      </div>
                      <div className="rpm-charges-total-badge">
                        <span>CHARGES TOTAL</span>
                        <strong className="rpm-charges-total-value">
                          {getStoreCurrencySymbol()}
                          {Number(
                            Number(localPackingCharge || 0) + Number(localDeliveryCharge || 0)
                          ).toFixed(0)}
                        </strong>
                      </div>
                    </div>
                    <div className="rpm-manual-charges-fields">
                      <div className="rpm-charge-field">
                        <label>Packing charge</label>
                        <div className="rpm-charge-input-wrap">
                          <input
                            type="text"
                            inputMode="decimal"
                            className="rpm-charge-input"
                            placeholder="0.00"
                            value={localPackingCharge}
                            onChange={(e) => handleChargeChange(e.target.value, "packing")}
                          />
                        </div>
                      </div>
                      {effectiveSaleMode === "DELIVERY" && (
                        <div className="rpm-charge-field">
                          <label>Delivery charge</label>
                          <div className="rpm-charge-input-wrap">
                            <input
                              type="text"
                              inputMode="decimal"
                              className="rpm-charge-input"
                              placeholder="0.00"
                              value={localDeliveryCharge}
                              onChange={(e) => handleChargeChange(e.target.value, "delivery")}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="rpm-charges-apply-row">
                      <button
                        type="button"
                        className="rpm-charges-cancel-btn"
                        onClick={() => {
                          setLocalPackingCharge("");
                          setLocalDeliveryCharge("");
                          setExtrasOpen(false);
                        }}
                        disabled={chargesApplying}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="rpm-charges-apply-btn"
                        onClick={handleApplyCharges}
                        disabled={chargesApplying}
                      >
                        {chargesApplying ? "Applying..." : "Apply"}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {isRestaurantVariant && Number(props?.total) === 0 ? (
                /* ═══ Zero-value order — nothing to tender ═══ */
                <div className="rpm-zero-amount-container">
                  <h2>Order Value: {getStoreCurrencySymbol()}0.00</h2>
                  <p>No payment methods are required.</p>
                  <button
                    className="rpm-process-btn"
                    onClick={handleProcessPaymentClick}
                    disabled={clickLock.current || isProcessing}
                    data-testid="button-complete-zero-order"
                  >
                    Complete Order
                  </button>
                </div>
              ) : (
                <>
                  {/* ── Payment method cards row ── */}
                  <div className="gpm-methods-section">
                    <div className="gpm-methods-label">PAYMENT METHODS</div>
                    <div className="gpm-methods-row">
                      {paymentButtons?.map((btn) => {
                        const isActive =
                          btn.method === "SPLIT"
                            ? props?.splitActive
                            : props?.paymentMethod === btn.method && !props?.splitActive;
                        return (
                          <button
                            key={btn?.method}
                            className={`gpm-method-card${isActive ? " active" : ""}`}
                            onClick={() => handleMethodClick(btn?.method)}
                            ref={btn?.method === "SPLIT" ? splitRef : undefined}
                            disabled={
                              (props?.splitActive && btn?.method !== "SPLIT") || isProcessing
                            }
                          >
                            <div className="gpm-method-icon-wrap">{methodIcon(btn.method)}</div>
                            <span>{btn?.label}</span>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* ── Body ── */}
                  {props?.splitActive ? (
                    /* ═══ SPLIT MODE body ═══ */
                    <div className="gpm-split-body">
                      <div className="gpm-split-card">
                        {/* Tabs + cancel */}
                        <div className="gpm-split-tabs-row">
                          <div className="gpm-split-tabs">
                            <button
                              className="gpm-split-tab active"
                              data-testid="button-split-mode-methods"
                              disabled={isProcessing}
                            >
                              <p className="gpm-split-tab-title">By payment methods</p>
                            </button>
                            <button
                              className="gpm-split-tab"
                              data-testid="button-split-mode-guest"
                              disabled={isProcessing}
                            >
                              <p className="gpm-split-tab-title">By guest</p>
                            </button>
                          </div>
                          <button
                            className="gpm-split-cancel-btn"
                            onClick={handleSplitCancel}
                            disabled={
                              props?.partialStatus || isProcessing || splitPayments?.length > 0
                            }
                          >
                            Cancel Split
                          </button>
                        </div>

                        {/* Two panels */}
                        <div className="gpm-split-panels">
                          {/* LEFT: Captured so far */}
                          <div className="gpm-split-panel-captured">
                            <div className="gpm-split-captured-header">
                              <div>
                                <h4 className="gpm-split-captured-title">Captured so far</h4>
                                <p className="gpm-split-captured-subtitle">
                                  Processed payments stay visible here while you complete the bill.
                                </p>
                              </div>
                              <span className="gpm-split-captured-badge">
                                {splitPayments?.length} payment
                                {splitPayments?.length !== 1 ? "s" : ""}
                              </span>
                            </div>

                            {splitPayments?.length === 0 ? (
                              <div
                                className="gpm-split-captured-empty"
                                data-testid="text-split-empty-state"
                              >
                                No split payments captured yet. Start with the next payment on the
                                right.
                              </div>
                            ) : (
                              <div className="gpm-split-payments-list">
                                {splitPayments?.map((p, i) => {
                                  if (i === 0) {
                                    return (
                                      <div
                                        key={i}
                                        className="gpm-split-primary-payment"
                                        data-testid="row-split-captured-1"
                                      >
                                        <div>
                                          <p
                                            className="gpm-split-primary-label"
                                            data-testid="text-split-method-label-1"
                                          >
                                            Primary payment
                                          </p>
                                          <p className="gpm-split-primary-method">
                                            {p?.method} captured
                                          </p>
                                        </div>
                                        <div className="gpm-split-primary-right">
                                          <p
                                            className="gpm-split-primary-amount"
                                            data-testid="text-split-method-amount-1"
                                          >
                                            {getStoreCurrencySymbol()}{p?.amount}
                                          </p>
                                          <p className="gpm-split-primary-status">Paid</p>
                                        </div>
                                      </div>
                                    );
                                  }
                                  return (
                                    <div key={i} className="gpm-split-payment-item">
                                      <span className="gpm-split-payment-method">{p?.method}</span>
                                      <span className="gpm-split-payment-amt">{getStoreCurrencySymbol()}{p?.amount}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* RIGHT: Add next payment */}
                          <div className="gpm-split-panel-add">
                            <div className="gpm-split-add-header">
                              <div>
                                <h4 className="gpm-split-add-title">Add next payment</h4>
                                <p className="gpm-split-add-subtitle">
                                  Capture any amount up to the remaining balance.
                                </p>
                              </div>
                              <button
                                className="gpm-use-remaining-btn"
                                data-testid="button-split-use-remaining"
                                disabled={isProcessing}
                                onClick={() => {
                                  const rem = props?.partialStatus
                                    ? props?.amountDue
                                    : props?.total;
                                  props?.setEnterAmount?.(String(roundAmountValue(Number(rem))));
                                }}
                              >
                                Use remaining
                              </button>
                            </div>

                            {/* Input Row for Method and Amount */}
                            <div className="gpm-split-inputs-row">
                              <div className="gpm-split-field">
                                <label
                                  className="gpm-split-field-label"
                                  htmlFor="split-current-method"
                                >
                                  Payment method
                                </label>
                                <select
                                  id="split-current-method"
                                  className="gpm-split-select"
                                  data-testid="select-split-current-method"
                                  disabled={isProcessing}
                                  value={props?.paymentMethod}
                                  onChange={(e) => props?.setPaymentMethod?.(e.target.value)}
                                >
                                  {payment_modes?.includes("CASH") && (
                                    <option value="CASH">Cash</option>
                                  )}
                                  {payment_modes?.includes("CARD") && (
                                    <option value="CARD">Card</option>
                                  )}
                                  {payment_modes?.includes("UPI") && (
                                    <option value="UPI">UPI</option>
                                  )}
                                  {allowCreditPayment &&
                                    customerPhoneNumber &&
                                    customerName &&
                                    retailType !== "RESTAURANT" && (
                                      <option value="DEBIT_NOTE">Credit</option>
                                    )}
                                </select>
                              </div>

                              <div className="gpm-split-field">
                                <label
                                  className="gpm-split-field-label"
                                  htmlFor="split-current-amount"
                                >
                                  Amount
                                </label>
                                <input
                                  autoFocus
                                  className="gpm-split-input"
                                  id="split-current-amount"
                                  data-testid="input-split-current-amount"
                                  disabled={isProcessing}
                                  type="number"
                                  ref={props?.enterAmountRef}
                                  value={
                                    props?.splitActive
                                      ? props?.enterAmount
                                      : roundAmountValue(Number(props?.total))
                                  }
                                  onChange={props?.handlesplitInputChange}
                                  placeholder="Enter amount"
                                />
                              </div>
                            </div>

                            {isSplitOverpaid && (
                              <p className="gpm-split-warning">
                                Entered amount is greater than total due
                              </p>
                            )}

                            <div className="gpm-split-bottom-hint">
                              <span className="gpm-split-hint-total">
                                Total amount to pay:{" "}
                                <strong>{getStoreCurrencySymbol()}{roundAmountValue(Number(props?.total))}</strong>
                              </span>{" "}
                              Choose the next tender and enter any amount up to
                              <span
                                style={{ fontWeight: "700", color: "#1e293b", fontSize: "20px" }}
                              >
                                {` ${getStoreCurrencySymbol()}${roundAmountValue(
                                  Number(props?.partialStatus ? props?.amountDue : props?.total)
                                )}`}
                              </span>
                              .
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    /* ═══ NORMAL body (2-col) ═══ */
                    <div className="gpm-body">
                      {/* LEFT PANEL – Active Tender */}
                      <div className="gpm-left-body">
                        <div className="gpm-at-card">
                          <div className="gpm-at-label">Active Tender</div>

                          <div className="gpm-at-name-row">
                            <span className="gpm-at-name">{methodLabel(props?.paymentMethod)}</span>
                            {(props?.paymentMethod === "CARD" ||
                              props?.paymentMethod === "UPI" ||
                              props?.paymentMethod === "SODEXO") && (
                              <span className="gpm-terminal-badge">
                                <span className="gpm-terminal-dot" />
                                TERMINAL READY
                              </span>
                            )}
                          </div>

                          {/* Stat boxes */}
                          <div className="gpm-stats-row">
                            <div className="gpm-stat-box">
                              <div className="gpm-stat-label">DUE</div>
                              <div className="gpm-stat-value">{getStoreCurrencySymbol()}{displayDue}</div>
                            </div>
                            <div className="gpm-stat-box">
                              <div className="gpm-stat-label">COLLECTED</div>
                              <div className={`gpm-stat-value ${collected > 0 ? "green" : ""}`}>
                                {getStoreCurrencySymbol()}{Math.round(collected)}
                              </div>
                            </div>
                            <div className="gpm-stat-box">
                              <div className="gpm-stat-label">REMAINING</div>
                              <div
                                className={`gpm-stat-value ${remaining === 0 ? "green" : "red"}`}
                              >
                                {getStoreCurrencySymbol()}{remaining}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Settlement summary */}
                        <div
                          className={`gpm-settlement-card ${
                            hasChange ? "has-change" : hasRemaining ? "has-remaining" : ""
                          }`}
                        >
                          <div className="gpm-settlement-label">Settlement Summary</div>
                          <div className="gpm-settlement-row">
                            {/* <span className="gpm-settlement-text">
                          {props?.paymentMethod === "DEBIT_NOTE"
                            ? "Credit order will be created for this amount."
                            : props?.paymentMethod === "CASH"
                            ? "Collect cash and enter amount received."
                            : `${methodLabel(
                                props?.paymentMethod
                              )} is ready for terminal processing.`}
                        </span> */}
                            <span className="gpm-settlement-amount">
                              {getStoreCurrencySymbol()}
                              {hasChange
                                ? Math.round(Number(changeAmount))
                                : hasRemaining
                                ? remaining
                                : roundAmountValue(Number(due))}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* RIGHT PANEL */}
                      <div className="gpm-right-card">
                        {props?.paymentMethod !== "CASH" && (
                          <>
                            <div className="gpm-rp-ready-label">Ready to Process</div>
                            <div className="gpm-rp-method-name">
                              {methodLabel(props?.paymentMethod)}
                            </div>
                          </>
                        )}

                        {/* Amount display box */}
                        {props?.paymentMethod !== "CASH" && (
                          <div className="gpm-amount-display">
                            <div>
                              <div className="gpm-amount-display-label">Amount</div>
                              <div className="gpm-amount-display-value">
                                {getStoreCurrencySymbol()}
                                {props?.amtHeading === "Recievable Amount"
                                  ? roundAmountValue(Number(props?.amtToBePaid))
                                  : props?.partialStatus
                                  ? roundAmountValue(Number(props?.amountDue))
                                  : props?.paymentMethod === "CASH" || roundOffValue
                                  ? roundAmountValue(Number(props?.total))
                                  : props?.total}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Cash-specific inputs */}
                        {props?.paymentMethod === "CASH" ? (
                          <>
                            {props?.amtHeading !== "Recievable Amount" && (
                              <div className="gpm-cash-input-wrapper">
                                <label className="gpm-cash-input-label">Amount received</label>
                                <div
                                  className="gpm-cash-input-box"
                                  onClick={() => props?.enterAmountRef?.current?.focus()}
                                >
                                  <span className="gpm-cash-rupee">{getStoreCurrencySymbol()}</span>
                                  <input
                                    autoFocus
                                    type="number"
                                    className="gpm-cash-input"
                                    value={props?.enterAmount}
                                    onChange={handleCashAmountChange}
                                    ref={props?.enterAmountRef}
                                    onClick={() => props?.enterAmountRef?.current?.focus()}
                                  />
                                </div>
                                {/* Quick-amount chips */}
                                <div className="gpm-chips-row">
                                  {[100, 200, 500, 2000].map((amt) => (
                                    <button
                                      key={amt}
                                      className="gpm-chip"
                                      onClick={() => props?.setEnterAmount?.(String(amt))}
                                    >
                                      {getStoreCurrencySymbol()}{amt}
                                    </button>
                                  ))}
                                  <button
                                    className="gpm-chip gpm-chip-exact"
                                    onClick={() =>
                                      props?.setEnterAmount?.(
                                        String(roundAmountValue(props?.total))
                                      )
                                    }
                                  >
                                    Exact
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        ) : props?.paymentMethod === "DEBIT_NOTE" ? (
                          <p className="gpm-terminal-info">
                            A credit order will be created for this customer. The outstanding
                            balance will be recorded against their account.
                          </p>
                        ) : (
                          /* Card / UPI / SODEXO */
                          <p className="gpm-terminal-info">
                            Send this amount to the connected terminal and complete the capture.
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ── Footer ── */}
                  <div className="gpm-footer">
                    {/* props.billPrintMode (not the defaulted value) so screens that do not
                    configure bill printing keep a single action button */}
                    {isRestaurantVariant &&
                      props?.billPrintMode === "ASK" &&
                      !props?.splitActive &&
                      !props?.isCreditPayment && (
                        <button
                          className="rpm-btn rpm-btn-outline rpm-print-pay-btn"
                          disabled={
                            !props?.cartItems?.length ||
                            clickLock.current ||
                            isCashUnderpayment ||
                            isSplitOverpaid ||
                            isProcessing
                          }
                          onClick={handlePrintBillAndPay}
                          data-testid="button-print-bill-and-pay"
                        >
                          <PrintOutlinedIcon sx={{ fontSize: "1rem" }} />
                          Print Bill and Pay
                        </button>
                      )}
                    <button
                      className="gpm-pay-btn"
                      disabled={
                        !props?.cartItems?.length ||
                        clickLock.current ||
                        isCashUnderpayment ||
                        isSplitOverpaid ||
                        isProcessing
                      }
                      onClick={handleProcessPaymentClick}
                    >
                      {isProcessing && <span className="gpm-pay-btn-spinner" />}
                      {isProcessing
                        ? "Processing…"
                        : props?.splitActive
                        ? splitPayments.length === 0
                          ? "Process Primary payment →"
                          : `Process Payment ${splitPayments.length + 1}`
                        : branchSubType === "FINE_DINE"
                        ? renderTotalAmount
                        : `(F2) ${renderTotalAmount}`}
                    </button>
                  </div>
                </>
              )}
            </div>
          )}

          {/* ── Bill Summary overlay ── */}
          {showBillSummary && (
            <div className="gpm-bill-overlay" onClick={() => setShowBillSummary(false)}>
              <div className="gpm-bill-card" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="gpm-bill-header">
                  <div className="gpm-bill-header-label">Bill Summary</div>
                  <div className="gpm-bill-header-title">Receipt</div>
                  <div className="gpm-bill-header-sub">
                    {props?.cartItems?.length || 0} item
                    {props?.cartItems?.length !== 1 ? "s" : ""}
                  </div>
                  <button
                    className="gpm-bill-header-close"
                    onClick={() => setShowBillSummary(false)}
                  >
                    ✕
                  </button>
                </div>

                {/* Body */}
                <div className="gpm-bill-body">
                  {/* Item list */}
                  {props?.cartItems?.map((item, i) => {
                    const name = item?.itemName || item?.name || item?.productName || "Item";
                    const qty =
                      item?.qty ??
                      item?.returnedQuantity ??
                      item?.quantity ??
                      item?.quantityBySpecs ??
                      1;
                    const unitPrice =
                      item?.price ?? item?.unitPrice ?? item?.rate ?? item?.sellingPrice ?? 0;
                    // Mirrors the printed bill: EXCLUSIVE lines show mrpTotal, others the
                    // (possibly returned) subTotal. `??` so a legitimate 0 is not skipped.
                    const lineValue =
                      item?.taxType === "EXCLUSIVE"
                        ? item?.mrpTotal
                        : item?.returnedSubTotal ?? item?.subTotal;
                    const lineTotal =
                      item?.amount ??
                      item?.total ??
                      item?.value ??
                      lineValue ??
                      Number(unitPrice) * Number(qty);
                    const note =
                      item?.note ||
                      item?.instructions ||
                      item?.instruction ||
                      item?.specialInstruction ||
                      "";
                    const addons = Array.isArray(item?.addonProduct) ? item.addonProduct : [];
                    return (
                      <div key={i}>
                        <div className="gpm-bill-item">
                          <span className="gpm-bill-item-name">
                            {name}
                            {note ? <em className="gpm-bill-item-note"> — {note}</em> : null}
                          </span>
                          <span className="gpm-bill-item-qty">×{qty}</span>
                          <span className="gpm-bill-item-value">
                            {getStoreCurrencySymbol()}{Number(lineTotal || 0).toFixed(2)}
                          </span>
                        </div>
                        {addons.map((addon, aIdx) => {
                          const addonQty = addon?.quantity ?? addon?.qty ?? 1;
                          const addonVal =
                            addon?.subTotal ??
                            Number(addon?.sellingPrice ?? addon?.price ?? 0) * Number(addonQty);
                          return (
                            <div key={aIdx} className="gpm-bill-item gpm-bill-item-addon">
                              <span className="gpm-bill-item-name">
                                + {addon?.itemName || addon?.name || addon?.productName || "Add-on"}
                              </span>
                              <span className="gpm-bill-item-qty">×{addonQty}</span>
                              <span className="gpm-bill-item-value">
                                {getStoreCurrencySymbol()}{Number(addonVal || 0).toFixed(2)}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}

                  <hr className="gpm-bill-divider" />

                  <div className="gpm-bill-summary-row">
                    <span>Subtotal</span>
                    <span>{getStoreCurrencySymbol()}{summaryData?.itemTotalDisplay ?? subTotal}</span>
                  </div>
                  {isRestaurantVariant && (
                    <>
                      <div className="gpm-bill-summary-row">
                        <span>Offers</span>
                        <span data-testid="text-payment-summary-offers">
                          -{getStoreCurrencySymbol()}{summaryData?.offersDisplay || 0}
                        </span>
                      </div>
                      <div className="gpm-bill-summary-row">
                        <span>Coupons</span>
                        <span data-testid="text-payment-summary-coupons">
                          -{getStoreCurrencySymbol()}
                          {Number(summaryData?.couponDisplay ?? props?.couponValue ?? 0).toFixed(0)}
                        </span>
                      </div>
                      <div className="gpm-bill-summary-row">
                        <span>Loyalty</span>
                        <span data-testid="text-payment-summary-loyalty">
                          -{getStoreCurrencySymbol()}
                          {Number(
                            summaryData?.loyaltyDisplay ?? props?.loyaltyPointsValue ?? 0
                          ).toFixed(0)}
                        </span>
                      </div>
                      <div className="gpm-bill-summary-row">
                        <span>Taxable value</span>
                        <span data-testid="text-payment-summary-taxable">
                          {getStoreCurrencySymbol()}
                          {summaryData?.taxableAmountDisplay ??
                            Math.max(
                              0,
                              Number(summaryData?.itemTotalDisplay ?? subTotal ?? 0) -
                                Number(summaryData?.cgstDisplay ?? cgst ?? 0) -
                                Number(summaryData?.sgstDisplay ?? sgst ?? 0) -
                                Number(summaryData?.cessDisplay ?? props?.cess ?? 0)
                            ).toFixed(2)}
                        </span>
                      </div>
                    </>
                  )}
                  {taxesToRender.length > 0 ? (
                    taxesToRender.map((tax, idx) => {
                      const taxName = tax?.taxName || tax?.name || "Tax";
                      const amount =
                        tax?.totalTaxAmount ??
                        tax?.taxAmount ??
                        tax?.amount ??
                        tax?.value ??
                        0;
                      return (
                        <div
                          className="gpm-bill-summary-row"
                          key={tax?.taxName ? `${tax.taxName}-${idx}` : idx}
                        >
                          <span>{taxName}</span>
                          <span>
                            {getStoreCurrencySymbol()}
                            {amount}
                          </span>
                        </div>
                      );
                    })
                  ) : (
                    <>
                      <div className="gpm-bill-summary-row">
                        <span>CGST</span>
                        <span>{getStoreCurrencySymbol()}{summaryData?.cgstDisplay ?? cgst}</span>
                      </div>
                      <div className="gpm-bill-summary-row">
                        <span>SGST</span>
                        <span>{getStoreCurrencySymbol()}{summaryData?.sgstDisplay ?? sgst}</span>
                      </div>
                    </>
                  )}
                  {isRestaurantVariant && (
                    <>
                      {Number(summaryData?.cessDisplay ?? props?.cess ?? 0) > 0 &&
                        !taxesToRender.some(
                          (t) => (t?.taxName || "").toUpperCase() === "CESS"
                        ) && (
                        <div className="gpm-bill-summary-row">
                          <span>CESS</span>
                          <span>
                            {getStoreCurrencySymbol()}{Number(summaryData?.cessDisplay ?? props?.cess ?? 0).toFixed(2)}
                          </span>
                        </div>
                      )}
                      {Number(summaryData?.packingChargesDisplay || 0) > 0 && (
                        <div className="gpm-bill-summary-row">
                          <span>Packing charges</span>
                          <span>{getStoreCurrencySymbol()}{Number(summaryData?.packingChargesDisplay || 0).toFixed(0)}</span>
                        </div>
                      )}
                      {Number(summaryData?.deliveryChargesDisplay || 0) > 0 && (
                        <div className="gpm-bill-summary-row">
                          <span>Delivery charges</span>
                          <span>
                            {getStoreCurrencySymbol()}{Number(summaryData?.deliveryChargesDisplay || 0).toFixed(0)}
                          </span>
                        </div>
                      )}
                      {Number(summaryData?.discountDisplay ?? props?.appliedDiscountAmt ?? 0) >
                        0 && (
                        <div className="gpm-bill-summary-row">
                          <span>Discount total</span>
                          <span>
                            -{getStoreCurrencySymbol()}
                            {Number(
                              summaryData?.discountDisplay ?? props?.appliedDiscountAmt ?? 0
                            ).toFixed(0)}
                          </span>
                        </div>
                      )}
                    </>
                  )}

                  <hr className="gpm-bill-divider" />

                  {/* Grand total */}
                  <div className="gpm-bill-grand">
                    <div className="gpm-bill-grand-label">
                      <span className="gpm-bill-grand-title">Grand Total</span>
                      <span className="gpm-bill-grand-includes">Includes taxes</span>
                    </div>
                    <span
                      className="gpm-bill-grand-amount"
                      data-testid="text-payment-summary-payable"
                    >
                      {getStoreCurrencySymbol()}{isRestaurantVariant ? restaurantDue : total}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default memo(PaymentModal);
